import PropTypes from 'prop-types';
import './style.scss';
import { useTranslation } from '@common/hooks/translation';

const mask = (name) => `${name.slice(0, 1)}${name.slice(1).replace(/./g, '*')}`;

const PlayerCard = ({
  data,
  variant = 'default',
  hasDelete,
  onDelete,
  extraRows = [],
}) => {
  const t = useTranslation();

  return (
    <div className={`player-card player-card-${variant}`}>
      <div className="player-card-content">
        <h3 className="player-card-name">
          {mask(data.FirstName)}
          &nbsp;
          {mask(data.LastName)}
        </h3>

        <div className="player-card-row">
          <span className="player-card-label">{t('Id:')}</span>
          <span className="player-card-value player-card-value-id">{data.Id}</span>
        </div>

        {extraRows.map((row, rowIndex) => (
          // eslint-disable-next-line
          <div key={rowIndex} className="player-card-row">
            <span className="player-card-label">{row.label}</span>
            &nbsp;
            <span className="player-card-value">{row.value}</span>
          </div>
        ))}
      </div>

      {hasDelete && <i className="player-card-delete-icon global-icon icon-Close" onClick={() => onDelete?.(data)} />}
    </div>
  );
};

PlayerCard.propTypes = {
  data: PropTypes.object.isRequired,
  variant: PropTypes.string,
  extraRows: PropTypes.arrayOf(PropTypes.object),
  hasDelete: PropTypes.bool,
  onDelete: PropTypes.func,
};

export default PlayerCard;
